import React, { useState } from 'react';
import { Typography, Paper, Grid } from '@mui/material';
import './suggestedQuestions.less';
const questions = [
    'what is my performance in Total Bars category?',
    'Can you split the performance by brands?',
    'How is my performance in Nutrition Segment',
    'What is my price incentive curve by brands in Nutrition segment across packsize?',
];

function SuggestedQuestions({ onQuestionClick }) {
    return (
        <Grid container spacing={2} className="suggested-questions">
            {questions.map((q, index) => (
                <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={0} className="question-card" onClick={() => onQuestionClick(q)}>
                        <Typography sx={{ fontSize: '14px' }}>{q}</Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
}

export default SuggestedQuestions;
